import { LanguageStorageService } from 'localization/LanguageStorageService';
import { FetchParams, Middleware, RequestContext } from './minside/runtime';

class AddLanguageMiddleware implements Middleware {
  async pre?(context: RequestContext): Promise<FetchParams | void> {
    // TODO: Get token language if we don't have a starting point?
    const language = LanguageStorageService.getPreferredLanguageOrDefault();

    const headers = context.init.headers as Record<string, string>;
    headers['accept-language'] = language.shortName;

    return context;
  }
}

export default AddLanguageMiddleware;
